import { useMutation } from "@tanstack/react-query";
import { CustomerAccount } from "models/accountSummary";
import { useAuthenticatedRequestCreator } from "./useRequests";

export interface ManualAdjustment {
    account: CustomerAccount;
    description: string;
    amountInCents: number;
}

const useCreateTransaction = () => {
    const createManualAdjustmentCreator = useAuthenticatedRequestCreator<
        boolean,
        ManualAdjustment
    >(adjustment => ({
        method: "post",
        url: "/transactions/manual-adjustment",
        data: {
            accountId: adjustment.account.id,
            description: adjustment.description,
            amountInCents: adjustment.amountInCents
        }
    }));

    const { mutateAsync: createManualAdjustment } = useMutation(
        (transaction: ManualAdjustment) =>
            createManualAdjustmentCreator(transaction)
    );

    return { createManualAdjustment };
};

export default useCreateTransaction;
